var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3189:50989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.875 18.0004C7.78106 18.0004 7.68656 17.9768 7.60106 17.9289C7.398 17.8159 7.2855 17.5892 7.31869 17.358L7.74731 14.3548C6.39394 13.2793 5.625 11.7476 5.625 10.1018C5.625 6.98719 8.40094 4.45312 11.8125 4.45312C15.2241 4.45312 18 6.98663 18 10.1018C18 13.2169 15.2241 15.7504 11.8125 15.7504C11.4947 15.7504 11.1746 15.7279 10.8596 15.6829L8.235 17.8704C8.13206 17.9565 8.00381 18.0004 7.875 18.0004ZM11.8125 5.57869C9.02138 5.57869 6.75 7.60763 6.75 10.1023C6.75 11.4883 7.452 12.7804 8.676 13.6466C8.84812 13.7687 8.93756 13.9768 8.90775 14.1855L8.63831 16.0704L10.3359 14.6552C10.4647 14.5494 10.6335 14.5028 10.7972 14.5343C11.1313 14.5944 11.4728 14.6254 11.8125 14.6254C14.6042 14.6254 16.875 12.5964 16.875 10.1018C16.875 7.60763 14.6042 5.57869 11.8125 5.57869Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.5467C2.15606 13.5467 2.06156 13.5231 1.97606 13.4752C1.773 13.3622 1.6605 13.1355 1.69369 12.9043L2.12231 9.90169C0.768938 8.82675 0 7.29394 0 5.64862C0 2.5335 2.77594 0 6.1875 0C8.52019 0 10.6301 1.18069 11.6944 3.08194C11.8468 3.3525 11.7501 3.69563 11.4784 3.8475C11.2078 3.99938 10.8641 3.90262 10.7134 3.6315C9.84769 2.08575 8.1135 1.125 6.1875 1.125C3.39638 1.125 1.125 3.15394 1.125 5.64862C1.125 7.03463 1.827 8.32669 3.051 9.1935C3.22312 9.315 3.31256 9.52312 3.28275 9.73238L3.01388 11.6168L4.21819 10.6127C4.45669 10.4136 4.81106 10.4462 5.01019 10.6847C5.20931 10.9238 5.17669 11.2787 4.93819 11.4772L2.61 13.4167C2.50706 13.5028 2.37881 13.5467 2.25 13.5467Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 10.6875C9.87316 10.6875 10.125 10.4357 10.125 10.125C10.125 9.81434 9.87316 9.5625 9.5625 9.5625C9.25184 9.5625 9 9.81434 9 10.125C9 10.4357 9.25184 10.6875 9.5625 10.6875Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 10.6875C12.1232 10.6875 12.375 10.4357 12.375 10.125C12.375 9.81434 12.1232 9.5625 11.8125 9.5625C11.5018 9.5625 11.25 9.81434 11.25 10.125C11.25 10.4357 11.5018 10.6875 11.8125 10.6875Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 10.6875C14.3732 10.6875 14.625 10.4357 14.625 10.125C14.625 9.81434 14.3732 9.5625 14.0625 9.5625C13.7518 9.5625 13.5 9.81434 13.5 10.125C13.5 10.4357 13.7518 10.6875 14.0625 10.6875Z",
    fill: "rgba(5, 125, 136, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3189:50989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconGreen);
export default __webpack_public_path__ + "static/media/comment-icon-green.d78fcb04fd7c789beb48c569851db264.svg";
export { ForwardRef as ReactComponent };